import { hasApiGeneratorPersistence, isApiGeneratorRoute } from "./apiGeneratorPersistence";
import { isEngineConfigRoute } from "./engineConfigPersistence";
import { isGetTokenRoute } from "./getTokenPersistence";
import { isHomeRoute } from "./homePersistence";
import { isMyApisRoute } from "./myApisPersistence";
import { isBillingRoute, isHelpCenterRoute, isProfileRoute } from "./dashboardRoutes";
import { isSubscriptionRoute } from "./subscriptionPersistence";

export const shouldBypassAuthLoading = (pathname) =>
  isHelpCenterRoute(pathname) ||
  isBillingRoute(pathname) ||
  (isApiGeneratorRoute(pathname) && hasApiGeneratorPersistence()) ||
  isEngineConfigRoute(pathname) ||
  isGetTokenRoute(pathname) ||
  isSubscriptionRoute(pathname) ||
  isMyApisRoute(pathname) ||
  isHomeRoute(pathname) ||
  isProfileRoute(pathname);
